import 'babel-polyfill';
import React from 'react'
import Root from './components/Root';
import { render  } from 'react-dom';

window.mountKozySlider = (mountId, props = {}) => {
    render(<Root {...props} />, document.getElementById(mountId))
}



// WEBPACK FOOTER //
// ./src/browser.js